import {
  formatDashDate,
  formatDate,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React from 'react'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  mode?: string
}

export const ProformaInvoicesDetailContent = (props: DetailProps) => {
  const { listEl, listStatus, userList } = props

  return (
    <>
      <div className="content-wrap full ">
        <div className="desc " style={{ color: 'grey' }}>
          Schedule Billing
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.ScheduledBillingID ? listEl?.title : 'N/A'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Invoice Date
        </div>
        <div className="mdDesc">{formatDate(listEl?.InvoiceDate)}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Transaction Date
        </div>
        <div className="mdDesc">{formatDate(listEl?.TransactionDate)}</div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Item
        </div>
        <div className="mdDesc"> {listEl?.Name}</div>
      </div>

      <div className="content-wrap full ">
        <div className="desc " style={{ color: 'grey' }}>
          Department
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.CostCentreID
            ? `${listEl?.DepartmentCode} | ${listEl?.DepartmentName}`
            : 'N/A'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Amount
        </div>
        <div className="mdDesc">{amtStr(listEl?.Amount)}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Doc Amount
        </div>
        <div className="mdDesc">{amtStr(listEl?.DocAmt)}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Tax Scheme
        </div>
        <div className="mdDesc"> {listEl?.Code} </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Tax Amount
        </div>
        <div className="mdDesc"> {amtStr(listEl?.TaxAmt)} </div>
      </div>

      <div className="content-wrap full ">
        <div className="desc " style={{ color: 'grey' }}>
          Reference No
        </div>
        <div className="mdDesc text-noflow">{listEl?.RefNo}</div>
      </div>

      <div className="content-wrap full ">
        <div className="desc " style={{ color: 'grey' }}>
          Description
        </div>
        <div className="mdDesc text-noflow">{listEl?.Description}</div>
      </div>

      <div className="content-wrap full ">
        <div className="desc " style={{ color: 'grey' }}>
          Remark
        </div>
        <div className="mdDesc text-noflow">{listEl?.Remark}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Created Date
        </div>
        <div className="mdDesc">{formatDate(listEl?.createdTs)}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Created By
        </div>
        <div className="mdDesc">
          {userList?.find(user => user.ID == listEl?.createdBy)?.name}
        </div>
      </div>

      {(listStatus === 'SUBMIT' || listStatus === 'COMPLETED') && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Submitted Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.submittedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Submitted By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {
                userList?.filter(user => user.ID == listEl?.submittedBy)[0]
                  ?.name
              }
            </div>
          </div>
        </>
      )}

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {userList?.filter(user => user.ID == listEl?.approvedBy)[0]?.name}
            </div>
          </div>
        </>
      )}

      {listEl?.isIssued && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Issued Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.IssuedDate)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Issued By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {userList?.filter(user => user.ID == listEl?.IssuedBy)[0]?.name}
            </div>
          </div>
        </>
      )}

      {listEl?.isBilled && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Billed Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(
                listEl?.BilledDate
                  ? listEl?.BilledDate ?? listEl?.IssuedDate
                  : formatDashDate(listEl?.modTs)
              )}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Billed By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {
                userList?.filter(
                  user =>
                    user.ID ==
                    (listEl?.BilledBy ?? listEl?.modBy ?? listEl?.IssuedBy)
                )[0]?.name
              }
            </div>
          </div>
        </>
      )}
    </>
  )
}
